import {
  CommunicationActionType,
  CommunicationAppearanceColor,
} from "../../models/institutional-communications";

export const communicationActionTypeOptions: Array<{
  label: string;
  value: CommunicationActionType;
}> = [
  { label: "Abrir detalle", value: "OPEN_DETAIL" },
  { label: "Redirección externa (URL)", value: "EXTERNAL_URL" },
];

export const communicationAppearanceColorOptions: Array<{
  label: string;
  value: CommunicationAppearanceColor;
}> = [
  { label: "Primario", value: "PRIMARY" },
  { label: "Éxito", value: "SUCCESS" },
  { label: "Advertencia", value: "WARNING" },
  { label: "Información", value: "INFO" },
  { label: "Ayuda", value: "HELP" },
];
